import { BatchedOperationError } from './errors'

type RunBatchedOperationParams<TBatch, TResult, TAggregate> = {
  batches: readonly TBatch[]
  initialAggregate: TAggregate
  runBatch: (batch: TBatch) => Promise<TResult>
  mergeIntoAggregate: (aggregate: TAggregate, result: TResult, batch: TBatch) => void
  getErrorMessage?: (cause: unknown) => string
  createError?: (params: { message: string; partialResult: TAggregate; failedBatch: TBatch; cause: unknown }) => Error
}

export async function runBatchedOperation<TBatch, TResult, TAggregate>(params: RunBatchedOperationParams<TBatch, TResult, TAggregate>): Promise<TAggregate> {
  const aggregate = params.initialAggregate

  for (const batch of params.batches) {
    try {
      const result = await params.runBatch(batch)
      params.mergeIntoAggregate(aggregate, result, batch)
    } catch (cause) {
      const message = params.getErrorMessage ? params.getErrorMessage(cause) : cause instanceof Error ? cause.message : 'Operation failed'
      const errorParams = {
        message,
        partialResult: aggregate,
        failedBatch: batch,
        cause,
      }

      if (params.createError) {
        throw params.createError(errorParams)
      }

      throw new BatchedOperationError(errorParams)
    }
  }

  return aggregate
}
